import { render, staticRenderFns } from "./DigiTization.vue?vue&type=template&id=7a02ea4c&scoped=true&"
import script from "./DigiTization.vue?vue&type=script&lang=js&"
export * from "./DigiTization.vue?vue&type=script&lang=js&"
import style0 from "./DigiTization.vue?vue&type=style&index=0&id=7a02ea4c&scoped=true&lang=css&"
import style1 from "./DigiTization.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a02ea4c",
  null
  
)

export default component.exports